module.exports = __webpack_public_path__ + "static/Relevant-Normal-1d7eddb2e920f4c03656251b4b7b7dac.woff";